import { render } from "./summary.vue?vue&type=template&id=3e63e7bd&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"

import "./summary.vue?vue&type=style&index=0&id=3e63e7bd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e63e7bd"]])

export default __exports__